import { Spinner } from "react-bootstrap";
export default function LoadingBtn() {
  return (
    <>
      <Spinner animation="border" role="status"></Spinner>
    </>
  ); 
}     